import { gql } from '@apollo/client';

import { LINE_ITEM_CUSTOM_PACING_FIELDS } from '../../apis/graphql/common/fragments/lineItem/lineItemCustomPacingFields';

export const DELETE_LINE_ITEM_CUSTOM_PACING_BY_IDS = gql`
  mutation deleteLineItemCustomPacingV5($lineItemIds: [String!]!) {
    deleteLineItemCustomPacingV5(lineItemIds: $lineItemIds) {
      success
      message
      lineItemId
      errorCode
      lineItem {
        ...lineItemCustomPacingFields
      }
    }
  }
  ${LINE_ITEM_CUSTOM_PACING_FIELDS}
`;
